import { render } from "./CompetitionsRegionMain.vue?vue&type=template&id=4a3329da&scoped=true"
import script from "./CompetitionsRegionMain.vue?vue&type=script&lang=js"
export * from "./CompetitionsRegionMain.vue?vue&type=script&lang=js"

import "./CompetitionsRegionMain.vue?vue&type=style&index=0&id=4a3329da&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3329da"]])

export default __exports__